const styleMap = {
  HEADER: {
    fontSize: '24px',
  },
};

export default styleMap;
